import StackedBarGraph from './StackedBarGraph'

export default StackedBarGraph
